import API from 'services/api';

import { IMailTaskItem } from '../models/IMailTaskItem';

export const getCalculationTemplates = (
  reservationId: string,
  partnerType: string,
): Promise<IMailTaskItem[]> =>
  API.get(`api/accommodation/templates/calculations/${reservationId}/partner/${partnerType}`).then(
    response => response?.data,
  );
